<div class="container" [ngStyle]="{padding: margin + 'px 0'}">
  <mat-spinner class="spinner" [ngStyle]="{ marginRight: text ? '' : '0' }" [diameter]="diameter"></mat-spinner>
  <span [innerHTML]="text | translate" [ngStyle]="{marginLeft: (diameter / 2) + 'px'}"></span>
</div>
